module.exports = __webpack_public_path__ + "img/logo-users.e103cde7.png";